import { createComponent } from '@/helpers/alpine';

const Navigation = createComponent(() => ({
    isNavOpen: false,
    isScrolled: false,
    currentIndex: null as string | null,
    currentChildIndex: null as string | null,
    currentSubChildIndex: null as string | null,
    topBanner: document.querySelector('.js-top-banner') as HTMLElement | null,

    init() {
        this.$watch('isNavOpen', () => {
            document.body.classList.toggle('overflow-hidden', this.isNavOpen);
        });

        if (
            (!document.body.classList.contains('page-category') &&
                !document.body.classList.contains('page-search')) ||
            document.body.classList.contains('page-univers')
        ) {
            this.checkScroll();
            window.addEventListener('scroll', () => this.checkScroll());
        }
    },

    checkScroll() {
        this.isScrolled = window.scrollY > 0;
    },

    navClose() {
        this.currentIndex = null;
        this.currentChildIndex = null;
        this.currentSubChildIndex = null;
        this.isNavOpen = false;
    },

    navToggle(index: string, force?: boolean | undefined) {
        if (this.currentIndex == null) {
            this.currentIndex = index;
        }

        if (index == this.currentIndex) {
            this.isNavOpen = force !== undefined ? force : !this.isNavOpen;
        }

        this.currentIndex = this.isNavOpen ? index : null;
        this.currentChildIndex = null;
        this.currentSubChildIndex = null;
    },

    navToggleChild(index: string) {
        this.currentChildIndex = this.isNavOpen ? index : null;
        this.currentSubChildIndex = null;
    },

    navToggleSubChild(index: string) {
        if (this.currentSubChildIndex == null) {
            this.currentSubChildIndex = index;
        } else {
            this.currentSubChildIndex = null;

            return;
        }

        this.currentSubChildIndex = this.isNavOpen ? index : null;
    },
}));

export { Navigation };
